import { render } from "./aproveProposalModal.vue?vue&type=template&id=3fb9f1ab"
import script from "./aproveProposalModal.vue?vue&type=script&lang=js"
export * from "./aproveProposalModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__